import { useCallback } from "react"
import { useFetcher } from "react-router"

import type { EnhancedConfigData } from "./brand-lenses-configuration"
import { SharedPanelsTab, type PanelsConfig } from "../shared/SharedPanelsTab"

export function PanelsTab({ data, config }: { data: EnhancedConfigData; config: PanelsConfig }) {
  const fetcher = useFetcher<{ success?: boolean; action?: string; errorMessage?: string }>()

  const isFetching = fetcher.state !== "idle"
  const currentAction = isFetching
    ? ((fetcher.json as { action?: "SAVE_SECTION" | "REMOVE_SECTION" } | undefined)?.action ?? null)
    : null

  const handleSave = useCallback(
    (panelsConfig: PanelsConfig) => {
      fetcher.submit(
        {
          action: "SAVE_SECTION",
          organisation: data.loadedOrganisation,
          project: data.loadedProject,
          jsonPath: "$.panels",
          value: panelsConfig,
          concurrency: data.existingConfig?.concurrency ?? "",
        },
        { method: "post", encType: "application/json" },
      )
    },
    [fetcher, data],
  )

  const handleRemove = useCallback(() => {
    fetcher.submit(
      {
        action: "REMOVE_SECTION",
        organisation: data.loadedOrganisation,
        project: data.loadedProject,
        jsonPath: "$.panels",
        concurrency: data.existingConfig?.concurrency ?? "",
      },
      { method: "post", encType: "application/json" },
    )
  }, [fetcher, data])

  return (
    <SharedPanelsTab
      config={config}
      onSave={handleSave}
      onRemove={handleRemove}
      isFetching={isFetching}
      currentAction={currentAction}
    />
  )
}
